<script>
export default {
  name: "LoadingSpinner",
  props: {
    size: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    sizeClass() {
      return this.size === 'sm' ? 'spinner spinner--sm' : 'spinner spinner--md';
    }
  }
}
</script>

<template>
  <span :class="sizeClass" aria-hidden="true"></span>
</template>

<style scoped>
.spinner {
  display: inline-block;
  border-style: solid;
  border-color: currentColor;
  border-right-color: transparent;
  border-radius: 999px;
  animation: spinner-rotate 0.8s linear infinite;
}

.spinner--sm {
  width: 14px;
  height: 14px;
  border-width: 2px;
}

.spinner--md {
  width: 18px;
  height: 18px;
  border-width: 2px;
}

@keyframes spinner-rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
